export default {
  apiEndpoint: "https://isi-website.prismic.io/api/v2",

  // -- Access token if the Master is not open
  // accessToken: 'xxxxxx',

  // OAuth
  // clientId: 'xxxxxx',
  // clientSecret: 'xxxxxx',

  // -- Links resolution rules
  // This function will be used to generate links to Prismic.io documents
  // As your project grows, you should update this function according to your routes
  linkResolver(doc) {
    if (doc.type === "resources") return `/resources/${doc.uid}`;
    if (doc.type === "news") return `/news/${doc.uid}`;
    if (doc.type === "projects") return `/core-activities/${doc.uid}`;
    if (doc.type === "publications") return `/projects/${doc.uid}`;
    if (doc.type === "advocacy_work") return `/raising-awareness/${doc.uid}`;
    if (doc.type === "focus_area") return `/focus-areas/${doc.uid}`;
    if (doc.type === "pages") return `/${doc.uid}`;
    if (doc.type === "event") return `/events/${doc.uid}`;
    if (doc.type === "year_of_action_resource")
      return `/year-of-action-resources/${doc.uid}`;

    return "/";
  }
};

export const apiEndpoint = "https://isi-website.prismic.io/api/v2";

export const accessToken =
  "MC5YZDZfOWhFQUFDWUFTeTYx.77-9HO-_vXrvv73vv71gDSDvv73vv73vv70R77-977-9Ze-_vXp_77-9G--_ve-_vTjvv73vv73vv73vv71Z77-977-9GQ";

export const linkResolver = doc => {
  if (doc.type === "resources") return `/resources/${doc.uid}`;
  if (doc.type === "news") return `/news/${doc.uid}`;
  if (doc.type === "projects") return `/core-activities/${doc.uid}`;
  if (doc.type === "publications") return `/projects/${doc.uid}`;
  if (doc.type === "advocacy_work") return `/raising-awareness/${doc.uid}`;
  if (doc.type === "focus_area") return `/focus-areas/${doc.uid}`;
  if (doc.type === "pages") return `/${doc.uid}`;
  if (doc.type === "event") return `/events/${doc.uid}`;
  if (doc.type === "year_of_action_resource")
    return `/year-of-action-resources/${doc.uid}`;

  return "/";
};



// WEBPACK FOOTER //
// ./src/prismic-configuration.js